import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
const team = [{
  id: 1,
  name: 'Dr Oluwatosin Olatujoye',
  role: 'Group Chief Executive Officer',
  company: 'Zylus Homes and Property Limited',
  image: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400&q=80'
}, {
  id: 2,
  name: 'Bukola Olatujoye',
  role: 'Chief Executive Officer',
  company: 'Zylus Group International',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&q=80'
}, {
  id: 3,
  name: 'Wasiu Sonekan',
  role: 'ED, Finance',
  company: 'Zylus Group',
  image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&q=80'
}, {
  id: 4,
  name: 'Lateef Lawal',
  role: 'Managing Director',
  company: 'Zylus Homes',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80'
}, {
  id: 5,
  name: 'Dr. Komolafe Taiwo',
  role: 'Group Chief Financial Officer',
  company: 'Zylus Group',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80'
}, {
  id: 6,
  name: 'Christian Onuoha',
  role: 'Group Head, Human Resources',
  company: 'Zylus Group',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80'
}, {
  id: 7,
  name: 'Sarah Adebayo',
  role: 'Head of Sales',
  company: 'Zylus Homes',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80'
}, {
  id: 8,
  name: 'Michael Okon',
  role: 'Head of Marketing',
  company: 'Zylus Group',
  image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&q=80'
}];
export function ManagementTeam() {
  const [selectedProfile, setSelectedProfile] = useState<(typeof team)[0] | null>(null);
  return <div className="pt-28 pb-24" data-id="element-1222">
      <PageHeader eyebrow="Leadership" title="Meet Our Management Team" subtitle="The Zylus Group International Management Team is a dynamic group of seasoned professionals dedicated to driving the company's vision of excellence in real estate, investment, and business development." breadcrumb={[{
      label: 'Home',
      href: '/'
    }, {
      label: 'About Us'
    }, {
      label: 'Management Team'
    }]} data-id="element-1223" />

      <div className="max-w-[1280px] mx-auto px-6 md:px-12 mt-16" data-id="element-1224">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1225">
          {team.map((member, i) => <motion.div key={member.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 4 * 0.1,
          duration: 0.6
        }} className="bg-white rounded-3xl p-6 text-center border border-ink/5 shadow-sm hover:shadow-xl transition-all duration-500 group" data-id="element-1226">
              <div className="relative w-32 h-32 mx-auto mb-5" data-id="element-1227">
                <div className="absolute inset-0 rounded-full border-4 border-gold/20 group-hover:border-gold transition-colors duration-500" data-id="element-1228" />
                <img src={member.image} alt={member.name} className="w-full h-full object-cover rounded-full p-1.5" data-id="element-1229" />
              </div>
              <h3 className="text-xl font-serif text-ink mb-1" data-id="element-1230">
                {member.name}
              </h3>
              <div className="text-[10px] font-bold text-gold uppercase tracking-wider mb-1" data-id="element-1231">
                {member.role}
              </div>
              <div className="text-[10px] text-ink/50 mb-6" data-id="element-1232">
                {member.company}
              </div>

              <button onClick={() => setSelectedProfile(member)} className="bg-bone hover:bg-gold hover:text-ink text-ink/70 font-semibold text-[10px] uppercase tracking-widest px-5 py-2 rounded-full transition-colors w-full" data-id="element-1233">
                View Profile
              </button>
            </motion.div>)}
        </div>
      </div>

      {/* Profile Modal */}
      <AnimatePresence data-id="element-1234">
        {selectedProfile && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setSelectedProfile(null)} className="fixed inset-0 bg-ink/60 backdrop-blur-sm z-50" data-id="element-1235" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md bg-white rounded-3xl p-8 z-50 shadow-2xl" data-id="element-1236">
              <button onClick={() => setSelectedProfile(null)} className="absolute top-6 right-6 w-8 h-8 bg-ink/5 hover:bg-ink/10 rounded-full flex items-center justify-center transition-colors" data-id="element-1237">
                <X className="w-4 h-4 text-ink" data-id="element-1238" />
              </button>

              <div className="flex flex-col items-center text-center" data-id="element-1239">
                <img src={selectedProfile.image} alt={selectedProfile.name} className="w-28 h-28 object-cover rounded-full border-4 border-gold mb-5" data-id="element-1240" />
                <h3 className="text-2xl font-serif text-ink mb-1" data-id="element-1241">
                  {selectedProfile.name}
                </h3>
                <div className="text-xs font-bold text-gold uppercase tracking-wider mb-1" data-id="element-1242">
                  {selectedProfile.role}
                </div>
                <div className="text-[10px] text-ink/50 mb-6 pb-6 border-b border-ink/10 w-full" data-id="element-1243">
                  {selectedProfile.company}
                </div>
                <p className="text-ink/70 text-sm leading-relaxed" data-id="element-1244">
                  With expertise across multiple sectors, {selectedProfile.name}{' '}
                  leads with a strategic focus on innovation, sustainable
                  growth, and value creation for all stakeholders.
                </p>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </div>;
}